import { Component, ElementRef, EventEmitter, Input, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridOptions } from 'ag-grid-community';
import * as _ from 'lodash';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { printFormateCss } from 'src/app/common/utils';
import { SharedService } from 'src/app/core/services';
import { LoanNRecoveriesRegisterFromCService } from '../../loan-n-recoveries-register-from-c/loan-n-recoveries-register-from-c.service';
import { GLOBAL } from 'src/app/app.globals';
import { ApiCallService } from 'src/app/service/api-call.service';
import { PaySlipService } from '../pay-slip.service';

@Component({
  selector: 'app-pay-slip-print',
  templateUrl: './pay-slip-print.component.html',
  styleUrls: ['./pay-slip-print.component.css']
})
export class PaySlipPrintComponent implements OnInit {
  selectedReportInfo: any;
  opratation: any;
  rowClassRules;
  public totalData: number;

  @Input() headerData: any;
  @ViewChild("templateStateRef") templateStateRef: TemplateRef<any>;
  @ViewChild('btnPrint') btnPrint: ElementRef<any>;
  @ViewChild("tablePrint") printtableEle: ElementRef;
  closeModal = new EventEmitter<void>();
  @Input() set selectedReportData(value: any) {
    if (value) {
      this.selectedReportInfo = value;
    }
  }

  get selectedReportData(): any {
    return this.selectedReportInfo;
  }
  @Input()
  public set reportData(value: any[]) {
    if (value) {

      this.reportValueData = value;
      const tempRowData = this.sharedService.agGridGroupRowOnProperties(this.groupingMeta, value);
      this.rowData = tempRowData;
      // this.rowData = value;
    }
  }
  public get reportData(): any[] {
    return this.reportValueData;
  }


  userId = localStorage.getItem("UserID");
  tableCss: string;
  totalRecords = 0;
  reportDate: string;

  tableRowData: any[] = [];
  rowData = [];
  // columnDefs: any[] = [];
  groupingMeta = ['ContractorNameWithSubContractor', 'WorkmenCategory'];
  private reportValueData: any[];

  stateList: any[] = [];
  paperSizeList: any[] = [];
  paperLayoutList: any = [];
  paperScalSizeList = [];

  // Enhanced paper size and layout options
  paperSizeOptions = [
    { value: 'A4', label: 'A4 (4 payslips per page)' },
    { value: 'A5', label: 'A5 (1 payslip per page)' }
  ];

  paperLayoutOptions = [
    { value: 'portrait', label: 'Portrait' },
    { value: 'landscape', label: 'Landscape' }
  ];

  showCenteralPrint: boolean = false;
  showStatePrint: boolean = false;
  PrintCongfigShow: boolean = false;

  pageCode = 349

  slipData: any

  actionFormGroup = new FormGroup({
    State: new FormControl(''),
    PaperSize: new FormControl(''),
    PaperLayout: new FormControl(''),
    PaperScalSize: new FormControl(['', [Validators.required, Validators.max(100)]]),
  });

  gridOptions: GridOptions = {
    animateRows: true,
    rowSelection: 'multiple',
    rowHeight: 40,
    headerHeight: 40,
    pagination: false,
    paginationPageSize: 0,
  };

  columnDefs = [
    { headerName: 'Sr. No.', pinned: 'left', headerClass: 'custom-header', field: 'id', width: 80 },
    { headerName: 'Sl. No. in Employee register', pinned: 'left', headerClass: 'custom-header', field: 'GatePassNo' },
    { headerName: 'Name', pinned: 'left', headerClass: 'custom-header', field: 'Name' },
    { headerName: 'Rate of Wage', pinned: 'left', headerClass: 'custom-header', field: 'MINIMUM_WAGE' },
    { headerName: 'No. of Days Worked', headerClass: 'custom-header', field: 'TPD_DAYS' },
    { headerName: 'Overtime hours worked', headerClass: 'custom-header', field: 'OVERTIME_HOURS' },
    // { headerName: 'BASIC+SP ACIAL_ALL', headerClass: 'custom-header', field: 'id' },
    { headerName: 'Special Basic', headerClass: 'custom-header', field: 'SPECIAL_BASIC' },
    { headerName: 'DA', headerClass: 'custom-header', field: 'DA' },
    { headerName: 'Payments Overtime', headerClass: 'custom-header', field: 'OT_PAYOUT' },
    { headerName: 'HRA', headerClass: 'custom-header', field: 'HRA' },
    { headerName: 'Leave @5% of Basic', headerClass: 'custom-header', field: 'LEAVE_PAY' },
    { headerName: 'Interim Bonus @8.33% of Basic', headerClass: 'custom-header', field: 'ADVANCE_BONUS' },
    { headerName: 'Any Other Allowance as per Appointment Letter', headerClass: 'custom-header', field: 'OTHRE_ALW' },
    { headerName: 'Any Other Allowance as per Appointment Letter', headerClass: 'custom-header', field: 'OTHRE1_ALW' },
    { headerName: 'Any Other Allowance as per Appointment Letter', headerClass: 'custom-header', field: 'OTHRE2_ALW' },
    { headerName: 'Total', headerClass: 'custom-header', field: 'TOTAL' },
    { headerName: 'PF', headerClass: 'custom-header', field: 'PF' },
    { headerName: 'ESIC', headerClass: 'custom-header', field: 'ESIC' },
    { headerName: 'Society', headerClass: 'custom-header', field: 'SOCIETY' },
    { headerName: 'Income Tax', headerClass: 'custom-header', field: 'INCOME_TAX' },
    { headerName: 'Insurance', headerClass: 'custom-header', field: 'INSURANCE' },
    // { headerName: 'OTHRE_DEDUCTION', headerClass: 'custom-header', field: 'id' },
    { headerName: 'Others(As per Appointment Letter)', headerClass: 'custom-header', field: 'OTHRE_DEDUCTION1' },
    { headerName: 'Others(As per Appointment Letter)', headerClass: 'custom-header', field: 'OTHRE_DEDUCTION2' },
    { headerName: 'Others(As per Appointment Letter)', headerClass: 'custom-header', field: 'OTHRE_DEDUCTION3' },
    { headerName: 'Recoveries', headerClass: 'custom-header', field: 'RECOVERIES' },
    { headerName: 'Total', headerClass: 'custom-header', field: 'DEDUCT' },
    { headerName: 'Net Payment', headerClass: 'custom-header', field: 'TOT_COST' },
    { headerName: 'Employer Share PF Welfare Fund', headerClass: 'custom-header', field: 'ESPWF' },
    { headerName: 'Receipt by Employee/Bank Transaction ID', headerClass: 'custom-header', field: 'RBEBTID' },
    { headerName: 'Date of Payment', headerClass: 'custom-header', field: 'DOP' },
    { headerName: 'Remarks', headerClass: 'custom-header', field: 'REMARKS' },
  ];

  constructor(
    private modalService: NgbModal,
    public apiCallService: LoanNRecoveriesRegisterFromCService,
    public apiCall: ApiCallService,
    private sharedService: SharedService,
    private paySlipService: PaySlipService
  ) {
    this.tableCss = printFormateCss();
  }

  ngOnInit() {
    this.totalData = this.reportValueData.length;
    this.reportDate = this.dateConvertor(this.selectedReportInfo);
    this.rowClassRules = {
      'group-row': (params) => {
        return params.data.groupLevel === 0;
      },
    };
    this.initializeData();
    this.getPrintOptionsFunc(this.pageCode);

    const params = {
      Company_Code: this.selectedReportData.Company,
      Plant_Code: this.selectedReportData.Plants,
      StartDate: moment(this.selectedReportData.DateRange[0]).format("YYYY-MM-DD"),
      RequireType: 0,
      Action: 0,
      RequestedUser: GLOBAL.USER_ID
    };

    this.apiCall.getMinimumWageMasterDetails(params).subscribe((response) => {
      this.slipData = response[0]
    });
  }

  rowIndexCellRenderer = (params) => {
    if (!params.data.parent) {
      return `<div style="padding: 5px">${params.data.rowIndex}</div>`;
    }
    return '<div></div>';
  }


  initializeData(): void {
    if (this.reportData.length) {
      this.reportDate = this.dateConvertor(this.selectedReportInfo);
      this.rowData = this.reportValueData;
      this.tableRowData = this.getGroupedRowData(this.reportData);
      this.rowData = this.tableRowData[0].items.map((item) => ({
        id: item.Id,
        Name: item.Name,
        GatePassNo: item.GatePassNo,
        MINIMUM_WAGE: item.MINIMUM_WAGE,
        TPD_DAYS: item.TPD_DAYS,
        OVERTIME_HOURS: item.OVERTIME_HOURS,
        SPECIAL_BASIC: item.SPECIAL_BASIC,
        DA: item.DA,
        OT_PAYOUT: item.OT_PAYOUT,
        HRA: item.HRA,
        LEAVE_PAY: item.LEAVE_PAY,
        ADVANCE_BONUS: item.ADVANCE_BONUS,
        OTHRE_ALW: item.OTHRE_ALW,
        OTHRE1_ALW: item.OTHRE1_ALW,
        OTHRE2_ALW: item.OTHRE2_ALW,
        TOTAL: item.TOTAL,
        PF: item.PF,
        ESIC: item.ESIC,
        SOCIETY: item.SOCIETY,
        INCOME_TAX: item.INCOME_TAX,
        INSURANCE: item.INSURANCE || '0',
        // OTHRE_DEDUCTION: item.OTHRE_DEDUCTION,
        OTHRE_DEDUCTION1: item.OTHRE_DEDUCTION1 || '0',
        OTHRE_DEDUCTION2: item.OTHRE_DEDUCTION2 || '0',
        OTHRE_DEDUCTION3: item.OTHRE_DEDUCTION3 || '0',
        RECOVERIES: item.RECOVERIES,
        DEDUCT: item.DEDUCT,
        TOT_COST: item.TOT_COST,
        ESPWF: item.ESPWF,
        RBEBTID: item.RBEBTID,
        DOP: item.DOP,
        REMARKS: item.REMARKS,
      }));
      this.totalRecords = this.reportData.length;
    }
  }

  getGroupedRowData(data: any[]): any[] {
    const groupedData = _.groupBy(data, 'ContractorName');
    return Object.keys(groupedData).map((key) => ({
      headerName: key,
      items: groupedData[key].map((item, index) => ({
        ...item,
        index: index + 1,
      })),
    }));
  }

  onPrintCentralFormat(): void {
    this.showCenteralPrint = true;
    this.showStatePrint = false;
    const data = {
      selectedReportData: this.selectedReportData,
      reportData: this.reportData
    };
    this.tableRowData = this.getGroupRowTableData(this.reportData);
    setTimeout(() => {
      let printConfOpt;
      if (this.PrintCongfigShow) {
        printConfOpt =
        {
          'PaperSize': this.actionFormGroup.controls.PaperSize.value,
          'PaperLayout': this.actionFormGroup.controls.PaperLayout.value,
          'PaperScalSize': this.actionFormGroup.controls.PaperScalSize.value
        }
      } else {
        printConfOpt =
        {
          'PaperSize': 'A5',
          'PaperLayout': 'portrait',
          'PaperScalSize': 100
        }
      }

      const tableCss = this.getPayslipCSS(printConfOpt.PaperSize);
      this.printPayslipTable('print-section', tableCss, printConfOpt);
      this.showCenteralPrint = false;
      localStorage.setItem('report-data', JSON.stringify(data));
    }, 100);
  }

  getGroupRowTableData(reportData: any[]): any[] {
    const tableData = [];
    const groupData = new Set(reportData.map(item => item.ContractorName));

    groupData.forEach((groupItem: string) => {
      let index = 1;
      const items = reportData.filter(item => item.ContractorName === groupItem);
      items.forEach((item: any) => {
        item.index = index;
        index++;
      });
      const rowItems = {
        items,
        ContractorName: groupItem
      };
      tableData.push(rowItems);
    });
    return tableData;
  }

  getPayslipCSS(paperSize: string): string {
    const baseCSS = `
      table {
        width: 100%;
        border-collapse: collapse;
      }
      th, td {
        border: 1px solid #000;
        padding: 8px;
        text-align: left;
      }
      th {
        background-color: #f2f2f2;
      }
      .payslip-header { 
        display: flex; 
        justify-content: center; 
        flex-direction: column; 
        align-items: center;
        margin-bottom: 10px;
      }
      .payslip-container {
        ` + (paperSize === 'A4' ? 'display: grid; grid-template-columns: 1fr 1fr; grid-template-rows: 1fr 1fr; gap: 10px; height: 100vh;' : 'width: 100%;') + `
      }
      .payslip-item {
        ` + (paperSize === 'A4' ? 'border: none !important; padding: 10px; page-break-inside: avoid;' : 'width: 100%; margin-bottom: 20px;') + `
      }
      .payslip-row { 
        grid-template-columns: repeat(2, 1fr); 
        display: grid; 
        gap: 10px;
      }
      .payslip-box { 
        display: flex; 
        flex-direction: column;
      }
      .payslip-name { 
        margin-top: 0; 
        font-size: ` + (paperSize === 'A4' ? '14px' : '18px') + `; 
        font-weight: 600;
      }
      .payslip-data-title { 
        display: inline-block; 
        margin-top: 0; 
        font-size: ` + (paperSize === 'A4' ? '12px' : '16px') + `; 
        font-weight: 500;
      }
      .payslip-data-text { 
        display: inline-block; 
        margin-top: 0;
        font-size: ` + (paperSize === 'A4' ? '11px' : '14px') + `;
      }
      .slip-sub-title { 
        font-size: ` + (paperSize === 'A4' ? '16px' : '22px') + `; 
        font-weight: 700;
      }
      .payslip-data-bottom { 
        width: ` + (paperSize === 'A4' ? '200px' : '500px') + `; 
        height: ` + (paperSize === 'A4' ? '60px' : '100px') + `; 
        background-color: #FFF; 
        border: 1px solid #000; 
        margin: 0;
      }
    `;
    return baseCSS;
  }

  printPayslipTable(elementId: string, tableCss: string, printConfOpt: any): void {
    const element = document.getElementById(elementId);

    if (!element) {
      console.error(`Element with ID ${elementId} not found`);
      return;
    }

    const paperSize = printConfOpt.PaperSize || 'A5';
    const recordsPerPage = paperSize === 'A4' ? 4 : 1;
    const pages = this.paginateData(this.reportData, recordsPerPage);
    const tableHeaderHtml = element.querySelector('thead') ? element.querySelector('thead').outerHTML : '';
    const tableBodyHtml = this.generatePayslipHTML(pages, tableHeaderHtml, this.reportData, paperSize);
    
    this.openPrintWindow(tableBodyHtml, tableCss, printConfOpt);
  }

  printTable(elementId: string, tableCss: string, printConfOpt: any): void {
    const element = document.getElementById(elementId);

    if (!element) {
      console.error(`Element with ID ${elementId} not found`);
      return;
    }

    const recordsPerPage = 1;
    const pages = this.paginateData(this.rowData, recordsPerPage);
    const tableHeaderHtml = element.querySelector('thead').outerHTML || '';
    const tableBodyHtml = this.generatePaginatedTableBody(pages, tableHeaderHtml, this.reportData);
    const printWindow = window.open('', '_blank', 'toolbar=no,scrollbars=yes,resizable=yes,top=0,left=0,width=800,height=600');
    if (printWindow) {
      const additionalCSS = `
        ${tableCss}
        @media print {
          @page {
            size: A5 ${printConfOpt.PaperLayout || 'portrait'};
            margin: 1cm;
          }
  
          body {
            font-size: 12px;
            color: #000;
            margin: 0;
            padding: 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
  
          table {
            width: 100%;
            border-collapse: collapse;
            page-break-inside: auto;
          }
  
          thead {
            display: table-header-group;
          }
  
          tfoot {
            display: table-footer-group;
          }
  
          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          th, td {
            border: 1px solid black;
            padding: 5px;
            text-align: left;
          }
  
          .no-print {
            display: none;
          }
  
          .page-break {
            margin-bottom: 1rem;
            page-break-after: always;
          }
  .underLine{
      font-size: 18px;
    text-decoration: underline;
    font-weight: 600;
    }
          .table-bordered {
            margin-bottom: 0px;
          }
            .payslip-header { display: flex; justify-content: center; flex-direction: column; align-items: center;}
            .payslip-row { grid-template-columns: repeat(2, 1fr); display: grid; gap: 10px;}
            .payslip-box { display: flex; flex-direction: column;}
            .payslip-name {  margin-top: 0; font-size: 18px; font-weight: 600;}
            .payslip-data-title { display: inline-block; margin-top: 0; font-size: 16px; font-weight: 500;}
            .payslip-data-text { display: inline-block; margin-top: 0;}
            .payslip-bottom-box { display: flex; justify-content: flex-end;}
            .payslip-bottom { display: flex; flex-direction: column;}
            .slip-sub-title { font-size: 22px; font-weight: 700;}
            .payslip-data-bottom { width: 500px; height: 100px; background-color: #FFF; border: 1px solid #000; margin: 0;}
        }`;

      printWindow.document.open();
      printWindow.document.write(`
        <html>
        <head>
          <title>Print Preview</title>
          <style>${additionalCSS}</style>
        </head>
        <body>
          ${tableBodyHtml}
        </body>
        </html>
      `);
      printWindow.document.close();

      printWindow.focus();
      printWindow.print();
      // printWindow.onafterprint = () => printWindow.close();
    } else {
      console.error('Failed to open print window');
    }
  }


  generatePayslipHTML(pages: any[][], headerHtml: string, tableRowData: any[], paperSize: string): string {
    if (!tableRowData || !Array.isArray(tableRowData) || tableRowData.length === 0) {
      console.error("tableRowData is undefined or empty");
      return '';
    }

    return pages.map((page, pageIndex) => {
      if (paperSize === 'A4') {
        return this.generateA4PayslipPage(page, pageIndex, pages.length);
      } else {
        return this.generateA5PayslipPage(page, pageIndex, pages.length);
      }
    }).join('');
  }

  generateA4PayslipPage(pageData: any[], pageIndex: number, totalPages: number): string {
    const payslips = pageData.map((rowData, index) => {
      return `
        <div class="payslip-item">
          ` + this.generateSinglePayslip(rowData, true) + `
        </div>
      `;
    }).join('');

    const remainingSlots = 4 - pageData.length;
    const emptySlots = Array(remainingSlots).fill(0).map(() => '<div class="payslip-item"></div>').join('');
    const pageBreak = pageIndex < totalPages - 1 ? '<div class="page-break"></div>' : '';

    return `
      <div class="payslip-container">
        ` + payslips + `
        ` + emptySlots + `
      </div>
      ` + pageBreak + `
    `;
  }

  generateA5PayslipPage(pageData: any[], pageIndex: number, totalPages: number): string {
    return pageData.map((rowData, index) => {
      const pageBreak = (pageIndex < totalPages - 1 || index < pageData.length - 1) ? '<div class="page-break"></div>' : '';
      return `
        <div class="payslip-item">
          ` + this.generateSinglePayslip(rowData, false) + `
        </div>
        ` + pageBreak + `
      `;
    }).join('');
  }

  generateSinglePayslip(rowData: any, isA4: boolean): string {
    const fontSize = isA4 ? 'small' : 'normal';
    const headerSize = isA4 ? '16px' : '22px';
    const padding = isA4 ? '5px' : '8px';
    const fontSizeText = isA4 ? '10px' : '14px';
    const headerFontSize = isA4 ? '12px' : '18px';
    const subTitleSize = isA4 ? '14px' : '18px';
    const signatureHeight = isA4 ? '40px' : '80px';
    
    return `
      <table style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th colspan="2" style="border-bottom: none; text-align: center; background-color: #fff; padding: ` + padding + `;">
              <div class="payslip-header">
                <h1 style="font-weight: 600; margin: 0; font-size: ` + headerSize + `;">FORM XIX</h1>
                <p style="margin: 0; font-size: ` + headerFontSize + `; font-weight: 500;">
                  [See rule 78 (1) (b)]
                </p>
                <h6 class="slip-sub-title" style="margin: 0; font-size: ` + subTitleSize + `;">Wage Slip</h6>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 50%; padding: ` + padding + `; vertical-align: top;">
              <div style="font-size: ` + fontSizeText + `;">
                <p><strong>Name and address of contractor</strong></p>
                <p style="text-decoration:underline; font-weight:600;">` + (this.headerData && this.headerData.Contractor ? this.headerData.Contractor : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (this.headerData && this.headerData.ContractorAddress ? this.headerData.ContractorAddress : '---') + `</p>
                <p><strong>Nature and location of work</strong></p>
                <p><strong>UAN No</strong></p>
                <p><strong>ESIC No</strong></p>
                <p><strong>Number of days worked</strong></p>
                <p><strong>Number of units worked in case of piece rate workers</strong></p>
                <p><strong>Rate of daily wages/piece rate</strong></p>
                <p><strong>Amount of overtime wages</strong></p>
                <p><strong>Gross wages payable</strong></p>
                <p><strong>Deductions, if any</strong></p>
                <p><strong>Net amount of wages paid</strong></p>
              </div>
            </td>
            <td style="width: 50%; padding: ` + padding + `; vertical-align: top;">
              <div style="font-size: ` + fontSizeText + `;">
                <p><strong>Name and father's/husband's name of the workman</strong></p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.Name ? rowData.Name : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.GatePassNo ? rowData.GatePassNo : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.WorkLocation ? rowData.WorkLocation : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.UANNo ? rowData.UANNo : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.ESICNo ? rowData.ESICNo : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.TPD_DAYS ? rowData.TPD_DAYS : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.UnitsWorked ? rowData.UnitsWorked : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.MINIMUM_WAGE ? rowData.MINIMUM_WAGE : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.OT_PAYOUT ? rowData.OT_PAYOUT : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.TOTAL ? rowData.TOTAL : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.DEDUCT ? rowData.DEDUCT : '---') + `</p>
                <p style="text-decoration:underline; font-weight:600;">` + (rowData && rowData.TOT_COST ? rowData.TOT_COST : '---') + `</p>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="padding: ` + padding + `; text-align: right;">
              <div style="height: ` + signatureHeight + `; border: 1px solid #000; border-radius: 4px; display: flex; align-items: end; justify-content: center; padding: 5px;">
                <p style="text-decoration:underline; font-weight:600; margin: 0; font-size: ` + fontSizeText + `;">
                  Signature of Contractor: ` + (this.headerData && this.headerData.Contractor ? this.headerData.Contractor : '') + `
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    `;
  }

  openPrintWindow(content: string, tableCss: string, printConfOpt: any): void {
    const printWindow = window.open('', '_blank', 'toolbar=no,scrollbars=yes,resizable=yes,top=0,left=0,width=800,height=600');
    if (printWindow) {
      const paperSize = printConfOpt.PaperSize || 'A5';
      const paperLayout = printConfOpt.PaperLayout || 'portrait';
      const marginSize = paperSize === 'A4' ? '0.5cm' : '1cm';
      const bodyFontSize = paperSize === 'A4' ? '10px' : '12px';
      const containerDisplay = paperSize === 'A4' ? 'display: grid; grid-template-columns: 1fr 1fr; grid-template-rows: 1fr 1fr; gap: 10px; height: 100vh;' : 'width: 100%;';
      const itemStyle = paperSize === 'A4' ? 'border: 2px solid #000; padding: 5px; page-break-inside: avoid;' : 'width: 100%; margin-bottom: 20px;';
      const pageBreakInside = paperSize === 'A4' ? 'avoid' : 'auto';
      const cellPadding = paperSize === 'A4' ? '3px' : '5px';
      const pageBreakHeight = paperSize === 'A4' ? 'height: 0;' : 'margin-bottom: 1rem;';
      
      const additionalCSS = `
        ` + tableCss + `
        @media print {
          @page {
            size: ` + paperSize + ` ` + paperLayout + `;
            margin: ` + marginSize + `;
          }

          body {
            font-size: ` + bodyFontSize + `;
            color: #000;
            margin: 0;
            padding: 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            page-break-inside: ` + pageBreakInside + `;
          }

          .payslip-container {
            ` + containerDisplay + `
          }

          .payslip-item {
            ` + itemStyle + `
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }

          th, td {
            border: 1px solid black;
            padding: ` + cellPadding + `;
            text-align: left;
          }

          .no-print {
            display: none;
          }

          .page-break {
            page-break-after: always;
            ` + pageBreakHeight + `
          }

          .payslip-header { 
            display: flex; 
            justify-content: center; 
            flex-direction: column; 
            align-items: center;
          }
        }
      `;

      printWindow.document.open();
      printWindow.document.write(`
        <html>
        <head>
          <title>Payslip Print Preview</title>
          <style>` + additionalCSS + `</style>
        </head>
        <body>
          ` + content + `
        </body>
        </html>
      `);
      printWindow.document.close();

      printWindow.focus();
      printWindow.print();
    } else {
      console.error('Failed to open print window');
    }
  }

  generatePaginatedTableBody(pages: any[][], headerHtml: string, tableRowData: any[]): string {
    if (!tableRowData || !Array.isArray(tableRowData) || tableRowData.length === 0) {
      console.error("tableRowData is undefined or empty");
      return '';
    }

    return pages.map((page, index) => ` 
      <table>
        ${headerHtml}
        <tbody>
          ${page.map((row, i) => {
      const rowData = tableRowData[i] || {};
      return `
            <tr>
              <td>
                <div class="row" style="justify-content: stretch;display: flex;">
                  <div class="col-md-6">
                    <p>Name and address of contractor</p>
                    <p style="text-decoration:underline; font-weight:600;">${this.headerData.Contractor || ''}</p>
                    <p style="text-decoration:underline; font-weight:600;">${this.headerData.ContractorAddress || ''}</p>
                    <p>Nature and location of work</p>
                    <p>UAN No</p>
                    <p>ESIC No</p>
                    <p>Number of days worked</p>
                    <p>Number of units worked in case of piece rate workers</p>
                    <p>Rate of daily wages/piece rate</p>
                    <p>Amount of overtime wages</p>
                    <p>Gross wages payable</p>
                    <p>Deductions, if any</p>
                    <p>Net amount of wages paid</p>
                  </div>
                  <div class="col-md-6">
                    <p>Name and father's/husband's name of the workman</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.Name || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.GatePassNo || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.UANNo || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.ESICNo || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.TPD_DAYS || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.UnitsWorked || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.MINIMUM_WAGE || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.PRE_OT_RATE || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.INCOME_TAX || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.DEDUCT || '---'}</p>
                    <p style="text-decoration:underline; font-weight:600;">${rowData.NetWages || '---'}</p>
                  </div>
                </div>
                <div class="row" style="display: flex;">
                <div class="col-md-4" style="width:90%"></div>
                <div class="col-md-8" style="height: 150px; border: 1px solid #000;border-radius:4px;display: flex; align-items:end; width:100%">
                  <p style="text-decoration:underline; font-weight:600;margin-left:20px;">${this.headerData.Contractor || ''}</p>
                </div>
                </div>
              </td>
            </tr>
            `;
    }).join('')}
        </tbody>
      </table>
      ${index < pages.length - 1 ? '<div class="page-break"></div>' : ''}
    `).join('');
  }


  paginateData(data: any[], recordsPerPage: number): any[][] {
    const pages = [];
    for (let i = 0; i < data.length; i += recordsPerPage) {
      pages.push(data.slice(i, i + recordsPerPage));
    }
    return pages;
  }

  dateConvertor(reportData: any): string {
    if (!reportData.Date) {
      return "";
    }
  }

  getPrintOptionsFunc(pageCode) {
    // Use PaySlipService instead of apiCallService for print configuration
    this.paySlipService.getPrintConfiguration(pageCode).subscribe((response) => {
      if (response && response[0] && response[0].PrintingCongfigShow) {
        const { PrintingCongfigShow, PrintPaperSize, PrintPaperLayout, PrintScaleSize } = response[0];

        this.PrintCongfigShow = PrintingCongfigShow;
        this.paperSizeList = PrintPaperSize ? PrintPaperSize.split(',') : ['A4', 'A5'];
        this.paperLayoutList = PrintPaperLayout ? PrintPaperLayout.split(',') : ['portrait', 'landscape'];
        this.paperScalSizeList = PrintScaleSize ? PrintScaleSize.split(',') : ['100'];

        const patchValues = {
          PaperSize: this.paperSizeList ? this.paperSizeList[0] : 'A5',
          PaperLayout: this.paperLayoutList ? this.paperLayoutList[0] : 'portrait',
          PaperScalSize: this.paperScalSizeList ? Math.min(parseInt(this.paperScalSizeList[0]), 100) : 100,
          State: this.stateList.length === 1 ? this.stateList[0].State_Code : null
        };
        this.actionFormGroup.patchValue(patchValues);
      } else {
        // Set default values when print config is not available
        this.PrintCongfigShow = true;
        this.paperSizeList = ['A4', 'A5'];
        this.paperLayoutList = ['portrait', 'landscape'];
        this.paperScalSizeList = ['100'];
        
        this.actionFormGroup.patchValue({
          PaperSize: 'A5',
          PaperLayout: 'portrait',
          PaperScalSize: 100,
          State: this.stateList.length === 1 ? this.stateList[0].State_Code : null
        });
      }
    }, (error) => {
      // Fallback to default configuration on error
      console.warn('Print configuration API failed, using defaults:', error);
      this.PrintCongfigShow = true;
      this.paperSizeList = ['A4', 'A5'];
      this.paperLayoutList = ['portrait', 'landscape'];
      this.paperScalSizeList = ['100'];
      
      this.actionFormGroup.patchValue({
        PaperSize: 'A5',
        PaperLayout: 'portrait',
        PaperScalSize: 100,
        State: this.stateList.length === 1 ? this.stateList[0].State_Code : null
      });
    });
  }

  exportExcel(): void {
    this.showCenteralPrint = true;
    this.showStatePrint = false;
    let filename = moment(new Date()).format(this.sharedService.datePickerSettings.placeHolder);
    setTimeout(() => {
      this.exportExcelWithLayout('Loan/Recoveries Report ' + filename, this.printtableEle, this.tableCss);
      this.showCenteralPrint = false;
    }, 100);
  }

  exportExcelWithLayout(name, table, dyncss) {
    if (table && table.nativeElement) {
      let style = "<style>" + dyncss + "</style>";
      let uri = 'data:application/vnd.ms-excel;base64,'
        , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->` + style + `</head><body><table>${table}</table></body></html>`
        , base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)))
        }
        , format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; })
        }
      var ctx = { worksheet: 'Sheet1', table: table.nativeElement.innerHTML, fileName: 'test' }
      let link = document.createElement('a');
      link.download = name + '.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    } else {
      console.error("Table element not found");
    }
  }

  onCloseAction(): void {
    this.closeModal.emit();
  }

  onStateDD(data: any): void {
    this.opratation = data;
    this.modalService.open(this.templateStateRef, { size: "sm", windowClass: 'modal-scrollbar-hide' });
  }
}
